module.exports = __webpack_public_path__ + "static/media/programming-languages.b792af2a.svg";